/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DetachSpecialPlaceFromDevicesCommand
 */
export interface DetachSpecialPlaceFromDevicesCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof DetachSpecialPlaceFromDevicesCommand
     */
    deviceIds: Array<string>;
}

export function DetachSpecialPlaceFromDevicesCommandFromJSON(json: any): DetachSpecialPlaceFromDevicesCommand {
    return DetachSpecialPlaceFromDevicesCommandFromJSONTyped(json, false);
}

export function DetachSpecialPlaceFromDevicesCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): DetachSpecialPlaceFromDevicesCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deviceIds': json['deviceIds'],
    };
}

export function DetachSpecialPlaceFromDevicesCommandToJSON(value?: DetachSpecialPlaceFromDevicesCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deviceIds': value.deviceIds,
    };
}


